import styled from 'styled-components';
import { Button, Form } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons';
import { theme } from '../../../../theme';

const { colors, filters, shadows } = theme;

export const FormControl = styled(Form.Control)`
  &.filter-form-control {
    display: block;
    width: 100%;
    height: 30px;
    padding: 0.65rem 30px;
    font-size: 10.8px;
    font-weight: 500 !important;
    line-height: 1.5;
    border: 1px solid ${theme.colors.secondary};
    color: ${theme.colors.textPrimary};
    background-color: ${colors.white};
    background-clip: padding-box;
    border-radius: 5px;
    transition: border-color 0.15s ease-in-out;
    overflow: visible;

    &::placeholder {
      color: ${theme.colors.secondary};
    }

    &:hover,
    &:active,
    &:focus {
      box-shadow: none !important;
      border: 1px solid ${theme.colors.secondary} !important;
      color: ${theme.colors.textPrimary} !important;
      outline: 0;
    }
  }
`;

export const DivCheckboxBlock = styled.div`
  position: relative;
  overflow: auto;
  height: 150px;
  margin: 13px 0 !important;
  min-height: 50px;
`;

export const DivWrapper = styled.div`
  max-height: 150px;
`;

export const FormText = styled(Form.Text)`
  &.filter-form-text {
    margin-top: 0;
    font-size: 10.8px !important;
    text-align: center;
    font-weight: 300;
    color: ${filters.inputFieldHint}!important;
  }
`;

export const SearchIcon = styled(Search)`
  position: absolute;
  left: 12px;
  top: 9px;
  color: ${theme.colors.secondary};
`;

export const ButtonCloseSearch = styled(Button)`
  &.filter-btn-close-search {
    position: absolute;
    right: 7px;
    top: 7px;
    padding: 0;
    border: none;
    background-color: unset;
    box-shadow: none !important;
    color: ${colors.textPrimary};
    opacity: 0.4;
    transition: opacity 0.15s ease-in-out;
    align-items: flex-start !important;
    min-height: unset !important;

    &:hover,
    &:active,
    &:focus {
      color: ${colors.textPrimary} !important;
      background-color: unset !important;
      box-shadow: none !important;
      opacity: 1;
    }
  }
`;

export const FormGroup = styled(Form.Group)`
  position: relative;

  &.isQuick {
    margin-bottom: 0;

    ${DivCheckboxBlock} {
      position: absolute;
      z-index: 2;
      margin: 0 !important;
      padding: 15px 5px;
      width: 220px;
      background: ${colors.white};
      box-shadow: ${shadows.box};
      border-radius: 5px;

      &.isHidden {
        z-index: -1;
        opacity: 0;
      }
    }

    ${FormControl} {
      min-height: 3rem;
      padding-left: 30px;
      padding-right: 30px;
      font-size: 0.923rem;
    }
    ${SearchIcon} {
      top: 14px;
    }
    ${ButtonCloseSearch} {
      top: 12px;
    }
  }
`;
